"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyTwilioCode = exports.sendTwilioCode = exports.changePassword = exports.resetPasswordConfirm = exports.resetPasswordRequest = exports.deleteSocialAccount = exports.fetchSocialAccounts = exports.fetchTwitterAccessToken = exports.fetchTwitterRequestToken = exports.firebaseToken = exports.logout = exports.connectGoogle = exports.connectTwitter = exports.connectFacebook = exports.loginWithGoogle = exports.loginWithTwitter = exports.loginWithFacebook = exports.login = exports.signup = exports.validateOrganizationId = void 0;
var js_base64_1 = require("js-base64");
var querystring_1 = __importDefault(require("querystring"));
var snakecase_keys_1 = __importDefault(require("snakecase-keys"));
var config_1 = __importDefault(require("../../config"));
var base_1 = require("./base");
var validateOrganizationId = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)("".concat(config_1.default.urls.organizations).concat(data, "/validate-organization-id"), 'GET')];
    });
}); };
exports.validateOrganizationId = validateOrganizationId;
var signup = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.signup, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.signup = signup;
var login = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.login, 'POST', {
                Authorization: "Basic ".concat(js_base64_1.Base64.encode("".concat(data.username, ":").concat(data.password))),
            })];
    });
}); };
exports.login = login;
var loginWithFacebook = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.loginWithFacebook, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken })))];
    });
}); };
exports.loginWithFacebook = loginWithFacebook;
var loginWithTwitter = function (accessToken, tokenSecret) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.loginWithTwitter, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken, tokenSecret: tokenSecret })))];
    });
}); };
exports.loginWithTwitter = loginWithTwitter;
var loginWithGoogle = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.loginWithGoogle, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken })))];
    });
}); };
exports.loginWithGoogle = loginWithGoogle;
var connectFacebook = function (token, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.connectFacebook, token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken })))];
    });
}); };
exports.connectFacebook = connectFacebook;
var connectTwitter = function (token, accessToken, tokenSecret) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.connectTwitter, token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken, tokenSecret: tokenSecret })))];
    });
}); };
exports.connectTwitter = connectTwitter;
var connectGoogle = function (token, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.connectGoogle, token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)({ accessToken: accessToken })))];
    });
}); };
exports.connectGoogle = connectGoogle;
var logout = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.logout, token, 'POST')];
}); }); };
exports.logout = logout;
var firebaseToken = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.firebaseToken, token)];
}); }); };
exports.firebaseToken = firebaseToken;
var fetchTwitterRequestToken = function (callbackUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var params;
    return __generator(this, function (_a) {
        params = (0, snakecase_keys_1.default)({ callbackUrl: callbackUrl });
        return [2 /*return*/, (0, base_1.callApi)("".concat(config_1.default.urls.twitterRequestToken, "?").concat(querystring_1.default.stringify(params)), 'GET')];
    });
}); };
exports.fetchTwitterRequestToken = fetchTwitterRequestToken;
var fetchTwitterAccessToken = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.twitterAccessToken, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.fetchTwitterAccessToken = fetchTwitterAccessToken;
var fetchSocialAccounts = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.socialAccounts, token)];
}); }); };
exports.fetchSocialAccounts = fetchSocialAccounts;
var deleteSocialAccount = function (token, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.socialAccounts, "/").concat(id, "/disconnect/"), token)];
}); }); };
exports.deleteSocialAccount = deleteSocialAccount;
var resetPasswordRequest = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.resetPassword, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.resetPasswordRequest = resetPasswordRequest;
var resetPasswordConfirm = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)(config_1.default.urls.resetPasswordConfirm, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.resetPasswordConfirm = resetPasswordConfirm;
var changePassword = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)(config_1.default.urls.changePassword, token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.changePassword = changePassword;
var sendTwilioCode = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)('auth/send-twilio-code/', 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.sendTwilioCode = sendTwilioCode;
var verifyTwilioCode = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApi)('auth/verify-twilio-code/', 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.verifyTwilioCode = verifyTwilioCode;
